import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {HoldPositionComponent} from '@app/my-account/holds/hold-position/hold-position.component';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {HoldsActions} from '@store/holds/holds.actions';
import {FALLBACK_HOLD} from '@store/holds/holds.fallback';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {Hold} from '@store/holds/holds.types';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {FALLBACK_CATALOG_RECORD_AVAILABILITY} from '@store/catalog/catalog.fallback';
import {NgTemplateOutlet} from '@angular/common';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';
import {OutlinedButtonComponent} from '@aviary/buttons/outlined-button/outlined-button.component';

@Component({
  selector: 'px-catalog-hold-actions',
  templateUrl: './catalog-hold-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HoldPositionComponent, SelectPipe, NgTemplateOutlet, FilledButtonComponent, ButtonRouteNameDirective, OutlinedButtonComponent]
})
export class CatalogHoldActionsComponent {
  public readonly selectors = CatalogSelectors.Stateless;
  public readonly availabilitySelectors = CatalogSelectors.Availability;
  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly patronStatusSelectors = PatronSelectors.AccountStatus;
  public readonly holdSelectors = HoldsSelectors.HoldsForCatalogRecords;
  public readonly holdStatelessSelectors = HoldsSelectors.Stateless;
  public readonly FALLBACK_CATALOG_RECORD_AVAILABILITY = FALLBACK_CATALOG_RECORD_AVAILABILITY;
  public readonly FALLBACK_HOLD = FALLBACK_HOLD;

  @Input({required: true}) public catalogRecord: CatalogRecord;
  @Input() public forTableColumn: boolean;
  private readonly store = inject(Store);

  public onPlaceHold(): void {
    this.store.dispatch(HoldsActions.placeHoldOrLogin(this.catalogRecord));
  }

  public onEditHold(hold: Hold, circulatingCopies: number): void {
    this.store.dispatch(HoldsActions.showEditHold({...hold, circulatingCopies}));
  }

  public get holdButtonSizeClass(): string {
    return this.forTableColumn ? 'w-full max-w-[15rem] min-w-[6.5rem] md:min-w-[10rem]' : 'w-[15rem]';
  }
}
